// import { createSelector } from 'reselect';

export const getName = state => state.getIn(['profile', 'name']);
export const getGender = state => state.getIn(['profile', 'gender']);
export const getEmail = state => state.getIn(['profile', 'email']);
export const getPhone = state => state.getIn(['profile', 'phone']);
export const getCity = state => state.getIn(['profile', 'city']);
export const getAddress = state => state.getIn(['profile', 'address']);
export const getTaiwanCity = state => state.getIn(['profile', 'TaiwanCity']);